import { fmt, kpiColor } from '@/utils/formatters';

interface KPICardsProps {
  kpi: Record<string, number | string | null>;
}

export default function KPICards({ kpi }: KPICardsProps) {
  const entries = Object.entries(kpi).filter(([key]) => key !== '数据期间');

  return (
    <div className="section">
      <div className="section-title">核心指标</div>
      <div className="kpi-grid">
        {entries.map(([label, value]) => (
          <div key={label} className={`kpi-card ${kpiColor(label)}`}>
            <div className="kpi-label">{label}</div>
            <div className="kpi-value">{fmt(value, label)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
